import { render } from "./OrderHistoryList.vue?vue&type=template&id=b64d8e3e&lang=html"
import script from "./OrderHistoryList.vue?vue&type=script&lang=js"
export * from "./OrderHistoryList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/richken/code/StoryPhonesWebsite/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__